import { render, staticRenderFns } from "./HighStateTypesDashboardStates.vue?vue&type=template&id=58583a8a&scoped=true"
import script from "./HighStateTypesDashboardStates.vue?vue&type=script&lang=js"
export * from "./HighStateTypesDashboardStates.vue?vue&type=script&lang=js"
import style0 from "./HighStateTypesDashboardStates.vue?vue&type=style&index=0&id=58583a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58583a8a",
  null
  
)

export default component.exports